import './AdminReferenceData.css';

export const PAGE_SIZES = [25, 50, 100];

/**
 * Prev / "Page x of y (N rows)" / Next + page-size picker for the admin
 * reference grids. `page` is 0-based to match the backend. A `totalCount` of
 * -1 means the backend did not count (registry without a query): the total
 * and page count are hidden and Next is enabled while a full page came back.
 */
function AdminPagination({ page, pageSize, totalCount, rowCount, onPageChange, onPageSizeChange, disabled = false }) {
  const known = typeof totalCount === 'number' && totalCount >= 0;
  const totalPages = known ? Math.max(1, Math.ceil(totalCount / pageSize)) : null;
  const canPrev = page > 0;
  const canNext = known ? page < totalPages - 1 : rowCount >= pageSize;

  return (
    <div className="admin-pagination">
      <button type="button" disabled={disabled || !canPrev} onClick={() => onPageChange(page - 1)}>Prev</button>
      <span className="admin-pagination-label">
        {known
          ? `Page ${page + 1} of ${totalPages} (${totalCount.toLocaleString()} rows)`
          : `Page ${page + 1}`}
      </span>
      <button type="button" disabled={disabled || !canNext} onClick={() => onPageChange(page + 1)}>Next</button>
      <label className="admin-pagination-size">
        Rows
        <select value={pageSize} disabled={disabled} onChange={e => onPageSizeChange(Number(e.target.value))}>
          {PAGE_SIZES.map(n => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
    </div>
  );
}

export default AdminPagination;
